export default class SidebarNav {
    constructor() {
        this.init();
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        const toggleButtons = document.querySelectorAll('.e-nav_submenu_toggle');
        
        toggleButtons.forEach(button => {
            button.addEventListener('click', (e) => this.handleToggle(e));
        });
    }

    handleToggle(e) {
        const button = e.currentTarget;
        const listItem = button.closest('li');
        const subMenu = listItem.querySelector('.sub-menu');
        const isExpanded = button.classList.contains('expanded');

        if (isExpanded) {
            // Collapse
            this.collapseSubmenu(button, subMenu);
        } else {
            // Expand
            this.expandSubmenu(button, subMenu);
        }
    }

    expandSubmenu(button, subMenu) {
        button.classList.add('expanded');
        button.setAttribute('aria-expanded', 'true');

        // Show submenu and animate height
        gsap.set(subMenu, { display: 'block', height: 'auto' });
        const height = subMenu.offsetHeight;
        gsap.fromTo(subMenu, 
            { height: 0 },
            { height: height, duration: 0.3, ease: 'power2.out' }
        );

        // Animate menu items
        const menuItems = subMenu.children;
        gsap.fromTo(menuItems,
            { opacity: 0, y: -20 },
            { 
                opacity: 1, 
                y: 0, 
                duration: 0.3,
                stagger: 0.05,
                ease: 'power2.out'
            }
        );
    }

    collapseSubmenu(button, subMenu) {
        button.classList.remove('expanded');
        button.setAttribute('aria-expanded', 'false');
        const menuItems = subMenu.children;

        let menuCollapseTl = gsap.timeline({
            defaults: {
                duration: 0.3,
                ease: 'power2.in'
            }
        });

        menuCollapseTl.to(menuItems, {
            opacity: 0,
            y: -20,
            duration: 0.2,
            stagger: {
                amount: 0.1,
                from: 'end',
            },
            ease: 'power2.in'
        })
        .to(subMenu, {
            height: 0,
            duration: 0.3,
            ease: 'power2.in',
            onComplete: () => {
                gsap.set(subMenu, { display: 'none' });
            }
        }, '-=50%');

    }
}
